const availableFilters = [
	{ label: 'Account', key: 'Account_Name__c', type: 'text'},
	{ label: 'Status', key: 'Status__c', type: 'list', values: ["Planned", "In Progress", "Declined", "Abandoned", "Executed" ]},
	{ label: 'Event Date', key: 'Event_date__c', type: 'date'},
];

export default availableFilters;
